import * as React from "react";
import {cx} from "emotion";

import "./left-menu-dropdown-default.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";

import {MenuInternalLink} from "../../../common/components/internal-link";
import {getAbsLink}       from "../../../common/get-abs-link";

export const rLmdDefault = ({items, navBlock}) => cs(
    consumeContext("themeScheme"),
    ({themeScheme}) => (
        <div className="left-menu-dropdown-mobile-default">
            {items.map((item, i) => cs(
                keyed(i),
                () => (
                    item.type === "internalUrl" ? (
                        MenuInternalLink({
                            to: item.link,
                            className: cx("item"),
                            style: {
                                color: themeScheme.xpresso.menuTextColor,
                            },
                            "xd-qa-type": "dropdown_item",
                            "xd-qa-name": "Mobile Sidebar Menu " + item.linkLabel,
                            children: item.linkLabel,
                            navBlock,
                        })
                    ) : item.type === "url" || item.type === "tel" ? (
                        <a {...{
                            className: "item",
                            href: getAbsLink(item.link),
                            "xd-qa-type": "dropdown_item",
                            "xd-qa-name": "Mobile Sidebar Menu " + item.linkLabel,
                            ...item.link === "s/custom-quote-request/" && {
                                target: "_blank"
                            },
                            style:{
                                color: themeScheme.xpresso.menuTextColor,
                            },
                            onClick: async (e) => {
                                e.preventDefault();
                                if (await navBlock?.block() === true) {
                                    return;
                                }
                                window.location.href = getAbsLink(item.link);
                            },
                        }}>
                            {item.linkLabel}
                        </a>
                    ) : item.type !== "email" && cs(
                        consumeContext("liveChatConfig"),
                        consumeContext("webchat"),
                        ({webchat, liveChatConfig}) => liveChatConfig && liveChatConfig.chatEnabled && (
                            <a {...{
                                className: cx("item"),
                                onClick: () => {
                                    webchat.show();
                                },
                                "xd-qa-type": "dropdown_item",
                                "xd-qa-name": "Mobile Sidebar Menu " + item.linkLabel,
                                style:{
                                    color: themeScheme.xpresso.menuTextColor,
                                },
                            }}>
                                {item.linkLabel}
                            </a>
                        )
                    )
                ),
            ))}
        </div>
    )
);